import { connect } from 'react-redux';

import addAbilityToOpenModal from '../../../utilities/modalHOC';
import { loadRates } from '../../Rates/actionsSagas';
import { getRates } from '../../Rates/selectors';
import {
  setActivateExamSuccess,
  setBuildAllExamsProgress,
  setBuildAllExamsSuccess,
  setBuildAllExamsWaiting,
  setCycle,
  setDutyState,
  setRank,
  setRate,
  setRemoveQuestionSuccess,
} from '../actions';
import {
  activateExam,
  buildAllExams,
  buildPracticeExam,
  checkBuildPEProgress,
  createPracticeExam,
  loadPracticeExamInformation,
  removeQuestion,
} from '../actionSagas';
import {
  getActivateExamSuccess,
  getActivateExamWaiting,
  getBuildAllExamsProgress,
  getBuildAllExamsSuccess,
  getBuildAllExamsWaiting,
  getBuildPracticeExamWaiting,
  getCycle,
  getDutyState,
  getExam,
  getNewQuestion,
  getPracticeExamInformationWaiting,
  getPracticeExamQuestions,
  getPracticeExams,
  getRank,
  getRate,
  getRatingExamId,
  getRemoveQuestionSuccess,
  getRemoveQuestionWaiting,
} from '../selectors';
import PracticeExams from './PracticeExams';

const mapStateToProps = (state) => ({
  practiceExams: getPracticeExams(state),
  questions: getPracticeExamQuestions(state),
  newQuestion: getNewQuestion(state),
  ratingExamId: getRatingExamId(state),
  waiting: getPracticeExamInformationWaiting(state),
  rates: getRates(state),
  rate: getRate(state),
  rank: getRank(state),
  dutyState: getDutyState(state),
  exam: getExam(state),
  selectedCycle: getCycle(state),
  buildPracticeExamWaiting: getBuildPracticeExamWaiting(state),
  removeQuestionSuccess: getRemoveQuestionSuccess(state),
  removeQuestionWaiting: getRemoveQuestionWaiting(state),
  activateExamSuccess: getActivateExamSuccess(state),
  activateExamWaiting: getActivateExamWaiting(state),
  buildAllExamsSuccess: getBuildAllExamsSuccess(state),
  buildAllExamsWaiting: getBuildAllExamsWaiting(state),
  progress: getBuildAllExamsProgress(state),
});

const mapDispatchToProps = (dispatch) => ({
  loadPracticeExamInformation: (rate, rank, dutyState, practiceExamId = null) =>
    dispatch(
      loadPracticeExamInformation(rate, rank, dutyState, practiceExamId),
    ),
  buildPracticeExam: (practiceExamId) =>
    dispatch(buildPracticeExam(practiceExamId)),
  createPracticeExam: (examId) => dispatch(createPracticeExam(examId)),
  removeQuestion: (practiceExamId, questionId) =>
    dispatch(removeQuestion(practiceExamId, questionId)),
  activateExam: (practiceExamId) => dispatch(activateExam(practiceExamId)),
  loadRates: () => dispatch(loadRates(null, true)),
  selectOption: (rate, rank, dutyState) => {
    dispatch(setRate(rate));
    dispatch(setRank(rank));
    dispatch(setDutyState(dutyState));
  },
  setCycle: (cycle) => dispatch(setCycle(cycle)),
  setRemoveQuestionSuccess: (value) =>
    dispatch(setRemoveQuestionSuccess(value)),
  setActivateExamSuccess: (value) => dispatch(setActivateExamSuccess(value)),
  buildAllExams: (payload) => dispatch(buildAllExams(payload)),
  setBuildAllExamsSuccess: (value) => dispatch(setBuildAllExamsSuccess(value)),
  setBuildAllExamsProgress: (value) =>
    dispatch(setBuildAllExamsProgress(value)),
  setBuildAllExamsWaiting: (value) => dispatch(setBuildAllExamsWaiting(value)),
  checkBuildPEProgress: () => dispatch(checkBuildPEProgress()),
});

const PracticeExamsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PracticeExams);

export default addAbilityToOpenModal(PracticeExamsContainer);
